import React, { useState } from 'react';

import { Modal, PaperTitle, Button, ButtonWithLoader, ButtonsContainer } from 'virtues-bootstrap';
import PropTypes from 'prop-types';

import UserLicense from 'components/UserLicense';
import s from './styles.module.scss';

const UserLicenseAgreementPopup = ({ t, authLogout, userAcceptAgreement, show }) => {
  const [isUpdating, startUpdade] = useState(false);
  return (
    <Modal className={s.modal} show={show ? 1 : 0}>
      <PaperTitle size="md" withBorder>
        {t('userLicenceAgreement.title')}
      </PaperTitle>
      <UserLicense />
      <PaperTitle size="md" className={s.topBorder}>
        <ButtonsContainer wrapped>
          <Button outlined onClick={authLogout} disabled={isUpdating}>
            {t('userLicenceAgreement.modalButtons.cancel')}
          </Button>
          <ButtonWithLoader
            onClick={() => {
              startUpdade(true);
              userAcceptAgreement();
            }}
            loading={isUpdating}
          >
            {t('userLicenceAgreement.modalButtons.accept')}
          </ButtonWithLoader>
        </ButtonsContainer>
      </PaperTitle>
    </Modal>
  );
};

UserLicenseAgreementPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  authLogout: PropTypes.func.isRequired,
  userAcceptAgreement: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default UserLicenseAgreementPopup;
